import { Box, Paper, Typography } from "@mui/material"

import {
    formatVehicleWeeklyPriceLabel,
    getVehicleCoverUrl,
    getVehicleDisplayName,
    getVehicleFuel,
    getVehicleTransmission,
} from "../../../utils/vehicleHelpers"

const SimilarVehicleCard = ({ car, onClick }) => {
    const priceLabel = formatVehicleWeeklyPriceLabel(car)

    return (
    <Paper
        variant="outlined"
        onClick={onClick}
        sx={{
            minWidth: 220,
            maxWidth: 240,
            flex: "0 0 auto",
            borderRadius: 2,
            overflow: "hidden",
            cursor: "pointer",
            borderColor: "rgba(0, 4, 53, 0.1)",
            transition: "box-shadow 0.15s ease",
            "&:hover": { boxShadow: "0 8px 24px rgba(0, 4, 53, 0.1)" },
        }}
    >
        <Box
            sx={{
                height: 130,
                backgroundImage: getVehicleCoverUrl(car) ? `url('${getVehicleCoverUrl(car)}')` : undefined,
                backgroundSize: "cover",
                backgroundPosition: "center",
                bgcolor: "#eef2f7",
            }}
        />
        <Box sx={{ p: 1.5 }}>
            <Typography variant="body2" fontWeight={800} color="#000435" noWrap>
                {getVehicleDisplayName(car)}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                {[getVehicleFuel(car), getVehicleTransmission(car)].filter(Boolean).join(" · ")}
            </Typography>
            {priceLabel && (
                <Typography variant="body2" fontWeight={800} color="#000435">
                    {priceLabel}
                    <Typography component="span" variant="caption" color="text.secondary" fontWeight={500}>
                        {" "}
                        /week
                    </Typography>
                </Typography>
            )}
        </Box>
    </Paper>
    )
}

export default SimilarVehicleCard
